(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    // theme.js focuses the close button whenever the drawer opens; remember how
    // the shopper is interacting so a tap does not paint the focus ring round it.
    const root = document.documentElement;
    document.addEventListener('pointerdown', () => { root.dataset.cartInput = 'pointer'; }, true);
    document.addEventListener('keydown', (event) => {
      if (!['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) root.dataset.cartInput = 'keyboard';
    }, true);
    const sync = (drawer) => {
      const open = drawer.hasAttribute('data-sheet-open');
      drawer.querySelectorAll('[data-cart-sheet-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    };
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-cart-sheet-toggle]');
      const drawer = toggle && toggle.closest('[data-cart-drawer]');
      if (!drawer) return;
      drawer.toggleAttribute('data-sheet-open');
      sync(drawer);
    });
    // The inner element is swapped after every cart change; keep the new toggle's aria-expanded in step.
    const watch = () => document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => new MutationObserver(() => sync(drawer)).observe(drawer, { childList: true, subtree: true }));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  })();

  } catch(e) { console.error(e); }
})();
})();
